export default "__VITE_ASSET__y$XhJyx9__"